export var PlayerEditTabKeys = {
    Profile: "playerProfile",
    Transactions: "playerTransactions",
};
export var PlayerEditTabs = function (playerName, t) { return [
    {
        label: playerName + t("playerManagement.playerEditDrawer.tabs.profile"),
        key: PlayerEditTabKeys.Profile,
    },
    {
        label: playerName + t("playerManagement.playerEditDrawer.tabs.transactions"),
        key: PlayerEditTabKeys.Transactions,
    },
]; };
